"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CampaignGoalTypes = exports.CampaignGoalMethods = exports.CampaignGoal = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * Represents an entry in the "campaign_goals" table.
 */
var CampaignGoalMethods = /*#__PURE__*/function () {
  function CampaignGoalMethods() {
    _classCallCheck(this, CampaignGoalMethods);
  }

  _createClass(CampaignGoalMethods, null, [{
    key: "hasAtLeastOneType",
    value: function hasAtLeastOneType(campaignGoal) {
      var types = campaignGoal.goals;
      return Object.keys(types !== null && types !== void 0 ? types : {}).length > 0;
    }
  }, {
    key: "isGoalValid",
    value: function isGoalValid(campaignGoal) {
      var _campaignGoal$goals;

      var allTypesHaveValidInputs = Object.keys((_campaignGoal$goals = campaignGoal.goals) !== null && _campaignGoal$goals !== void 0 ? _campaignGoal$goals : {}).every(function (key) {
        var _campaignGoal$goals2;

        var curr = (_campaignGoal$goals2 = campaignGoal.goals) === null || _campaignGoal$goals2 === void 0 ? void 0 : _campaignGoal$goals2[key];

        if (campaignGoal.source === 'instagram' && key === 'carousel') {
          return curr && typeof curr['content'] === 'number' && curr['content'] > 0 && typeof curr['post'] === 'number' && curr['post'] > 0;
        }

        return curr && typeof curr === 'number' && curr > 0;
      });
      return CampaignGoalMethods.hasAtLeastOneType(campaignGoal) && allTypesHaveValidInputs;
    }
  }, {
    key: "getCarouselPostCount",
    value: function getCarouselPostCount(goalValue) {
      return goalValue && _typeof(goalValue) === 'object' && ['number', 'string'].includes(_typeof(goalValue['post'])) ? Number(goalValue['post']) : undefined;
    }
  }, {
    key: "getCarouselContentCount",
    value: function getCarouselContentCount(goalValue) {
      return goalValue && _typeof(goalValue) === 'object' && ['number', 'string'].includes(_typeof(goalValue['content'])) ? Number(goalValue['content']) : undefined;
    }
  }, {
    key: "parseGoal",
    value: function parseGoal(goalName, goalValue) {
      if (goalName === 'carousel') {
        return {
          post: CampaignGoalMethods.getCarouselPostCount(goalValue),
          content: CampaignGoalMethods.getCarouselContentCount(goalValue)
        };
      }

      return goalValue ? Number(goalValue) : null;
    }
  }]);

  return CampaignGoalMethods;
}();
/**
 * @deprecated - use the campaign goal methods instead
 */


exports.CampaignGoalMethods = CampaignGoalMethods;
var CampaignGoalTypes;
/**
 * @deprecated - use the campaign goal methods instead
 */

exports.CampaignGoalTypes = CampaignGoalTypes;

(function (CampaignGoalTypes) {
  CampaignGoalTypes["Instagram"] = "instagram";
  CampaignGoalTypes["Tiktok"] = "tiktok";
})(CampaignGoalTypes || (exports.CampaignGoalTypes = CampaignGoalTypes = {}));

/**
 * @deprecated - use the above instead
 */
var CampaignGoal = /*#__PURE__*/function () {
  function CampaignGoal(data) {
    _classCallCheck(this, CampaignGoal);

    _defineProperty(this, "goals", {});

    _defineProperty(this, "notes", '');

    Object.assign(this, data);
  }

  _createClass(CampaignGoal, [{
    key: "hasAtLeastOneType",
    value: function hasAtLeastOneType() {
      var types = this.goals;
      return Object.keys(types).length > 0;
    }
  }, {
    key: "isGoalValid",
    value: function isGoalValid() {
      var _this = this;

      var allTypesHaveValidInputs = Object.keys(this.goals).every(function (key) {
        var curr = _this.goals[key];

        if (_this.source === CampaignGoalTypes.Instagram && key === 'carousel') {
          return curr.content > 0 && curr.post > 0;
        }

        return curr > 0;
      });
      return this.hasAtLeastOneType() && allTypesHaveValidInputs;
    }
  }]);

  return CampaignGoal;
}();

exports.CampaignGoal = CampaignGoal;